import styled from "styled-components";
import { Overlay } from "./modals.style";
import WarningImg from "../../assets/warning.png";
import BackgroundImage from "../../assets/bg-grid-2.png";
import Text from "../Text";
import Button from "../Button";

import BackImg from "../../assets/back-btn.png";
import NextImg from "../../assets/next-btn.png";

const ModalContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: url(${BackgroundImage});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-color: #fefbed;
  border-radius: 10px;
  padding: 50px 130px;
  z-index: 1000;
  width: 300px;
  text-align: center;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ModalImage = styled.img`
  width: 75px;
  height: 75px;
`;

const WarningModal = ({ open, onClose }) => {
  if (!open) return null;

  const handleGuestConfirm = () => {
    // Clear previous session just in case
    sessionStorage.clear();

    // Set guest session values
    sessionStorage.setItem("is_guest", "true");
    sessionStorage.setItem("points_guest", "0");
    sessionStorage.setItem("conquered_castles", "[]");
    sessionStorage.setItem("conquered_castle_colors", "{}");
    sessionStorage.setItem("failed_castles", "[]");

    // Go to customization
    window.location.href = "/customize";
  };

  return (
    <>
      <Overlay />
      <ModalContainer>
        <ModalImage src={WarningImg} alt="Warning" />
        <Text
          fontFamily="'Source Serif 4'"
          fontWeight="700"
          fontSize="40px"
          lineheight="55px"
          color="#3E626A"
          margin="-15px 0 10px 0"
        >
          Προσοχή
        </Text>
        <Text
          fontFamily="Manrope"
          fontWeight="600"
          fontSize="16px"
          lineheight="21.86px"
          color="#3E626A"
          margin="0 0 25px 0"
        >
          Παραλείποντας τη σύνδεση η προοδός σας δεν θα αποθηκεύεται.
        </Text>
        <div style={{ display: "inline-flex", gap: "20px" }}>
          <Button onClick={onClose} imgurl={BackImg} />
          <Button onClick={handleGuestConfirm} imgurl={NextImg} />
        </div>
      </ModalContainer>
    </>
  );
};

export default WarningModal;
